import * as d3 from "d3";
import React from "react";
import { MouseEvent, useEffect, useMemo, useRef, useState } from "react";
export interface IMultibarData {
  index: number;
  BarData: number[];
  legendsHOB: string[];
  colors: string[];
}
export interface IGroupedDataCombined {
  label: string;

  values: IMultibarData[];
}
export interface ILineData {
  index: number;
  value: number;
}
interface Props {
  data: IGroupedDataCombined[];

  PercentageSign: string;
  colorsForBars: string[];
  YoYGrowth: number[];
  lineData: [number, number][];
  showLegends: Boolean;
  marginbottom: any;
}

interface BarProps {
  x: number;
  y: number;
  r: number;
  width: number;
  height: number;
  color: string;
  onMouseEnter: (e: MouseEvent<SVGPathElement>) => void;
  onMouseLeave: () => void;
}

interface Tooltip {
  x: number;
  y: number;
  index: number;
  barIndex: number;

  stackIndex: number;
}

function Bar({
  x,
  y,
  width,
  height,
  color,
  onMouseEnter,
  onMouseLeave,
  r,
}: BarProps) {
  const radius = r;

  return (
    <path
      d={`
      m${x},${y + radius}
      a${radius},${radius} 0 0 1 ${radius},${-radius}
      h${width - 2 * radius}
      a${radius},${radius} 0 0 1 ${radius},${radius}
      v${height - radius}
      h-${width}
      z
    `}
      fill={color}
      onMouseEnter={(event) => onMouseEnter(event)}
      onMouseLeave={onMouseLeave}
    />
  );
}
export function GroupedStackedChart({
  data,
  PercentageSign,
  colorsForBars,
  YoYGrowth,
  lineData,
  marginbottom,
  showLegends,
}: Props) {
  //  useEffect(() => {}, []);
  const [tooltip, setTooltip] = useState<Tooltip | null>(null);
  const axisBottomRef = useRef<SVGGElement>(null);
  const axisLeftRef = useRef<SVGGElement>(null);
  const chartRef = useRef(null);
  const svgContainer: any = d3.select(chartRef.current).node();
  var BottomDivWidth = svgContainer?.getBoundingClientRect()?.width || 700;
  //var BottomDivWidth: any =document.getElementById("barchartdivNVFleetRatio")?.clientWidth || 715;
  var BottomDivHeight: any = document.getElementById(
    "barchartdivNVFleetRatio"
  )?.clientHeight;
  const margin = { top: 30, right: 0, bottom: marginbottom, left: 65 };
  let width = BottomDivWidth - 15 - margin.left - margin.right || 0;
  const height = 350 - margin.top - margin.bottom;

  const labels = data.map(({ label }) => label);
  var sublabels: any = [];
  if (data[0]) sublabels = Object.keys(data[0].values);

  const scaleX = d3.scaleBand().domain(labels).range([0, width]).padding(0.2);
  const subscaleX = d3
    .scaleBand()
    .domain(sublabels)
    .range([0, scaleX.bandwidth()])
    .padding(0.1);
  var maxYscale = 0;
  data.map((d) => {
    d.values.map((v) => {
      var localMax = 0;
      v.BarData.map((v1) => {
        localMax = localMax + v1;

        if (localMax > maxYscale) maxYscale = localMax;
      });
    });
  });
  if (lineData.length > 0) {
    lineData.map((d) => {
      var localMax = d[1];

      if (localMax > maxYscale) maxYscale = localMax;
    });
  }
  maxYscale = maxYscale + 50;

  const scaleY = d3.scaleLinear().domain([0, maxYscale]).range([height, 0]);

  const [refresh, setrefresh] = useState(false);

  useEffect(() => {
    const svgContainer: any = d3.select(chartRef.current).node();
    var BottomDivWidth = svgContainer?.getBoundingClientRect()?.width || 700;

    width = BottomDivWidth - 15 - margin.left - margin.right || 0;
    setrefresh(!refresh);
  }, [width]);

  const [tooltipHeight, setTooltipHeight] = useState<number>(0);
  useEffect(() => {
    width = BottomDivWidth - 15 - margin.left - margin.right || 0;
    if (axisBottomRef.current) {
      d3.select(axisBottomRef.current)
        .call(d3.axisBottom(scaleX))
       ;
    }

    if (axisLeftRef.current) {
      d3.select(axisLeftRef.current).call(
        d3
          .axisLeft(scaleY)
          .tickValues(
            d3.range(0, maxYscale + 10, Math.round(maxYscale / 5 / 10) * 10)
          )
          .tickFormat(function (d, i) {
            return PercentageSign + d?.toLocaleString();
          })
      );
    }
  }, [scaleX, scaleY]);

  var sum = 0;
  var valuewithOutSum: any = [];
  var nextSum = 0;
  function GetNextSum(currentindex: any, array: any) {
    var sum = 0;
    for (let index = currentindex + 1; index < array.length; index++) {
      sum += array[index];
    }
    return sum;
  }
  d3.select(".Legend2").select("svg").remove();
  const linePath =
    d3
      .line()
      .x(
        (d) =>
          (scaleX(labels[d[0] - 1]) || 0) + margin.left + scaleX.bandwidth() / 2
      )
      .y((d) => scaleY(d[1]) + margin.top)(lineData) || undefined;

  useEffect(() => {
    // Calculate the tooltip height after the component has rendered
    const tooltipContent = document.querySelector(".tooltip");
    if (tooltipContent) {
      setTooltipHeight(tooltipContent.clientHeight);
    }
  }, [tooltip]);

  function calculateTooltipTop(y: number) {
    const maxTop = window.innerHeight - tooltipHeight - 10; // Adjust as needed
    return y > maxTop ? maxTop : y;
  }
  var localValues: any = [];
  return (
    <div className="" ref={chartRef}>
      <svg
        width={width + margin.left + margin.right}
        height={height + margin.top + margin.bottom}
      >
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g ref={axisBottomRef} transform={`translate(0, ${height})`} />
          <g ref={axisLeftRef} />
          {data.map(({ label, values }, groupIndex) => (
            <g
              key={`rect-group-${groupIndex}`}
              transform={`translate(${scaleX(label)}, 0)`}
            >
              {values.map(
                (barvalue, OuterbarIndex) => (
                  (sum = 0),
                  (valuewithOutSum = barvalue.BarData),
                  (localValues = barvalue.BarData),
                  (localValues = localValues.map(
                    (value: any) => (sum += value)
                  )),
                  (
                    <>
                      {localValues.map(
                        (value: any, stackIndex: any) => (
                          (nextSum = GetNextSum(stackIndex, valuewithOutSum)),
                          valuewithOutSum[stackIndex] > 0 ? (
                            <>
                              <g
                                key={`rect-group2-${groupIndex * stackIndex}`}
                                transform={`translate(${subscaleX(
                                  String(barvalue.index)
                                )}, 0)`}
                              >
                                <Bar
                                  key={`rect-222-${
                                    stackIndex + "," + OuterbarIndex
                                  }`}
                                  x={0}
                                  y={scaleY(value)}
                                  width={subscaleX.bandwidth()}
                                  r={
                                    stackIndex < barvalue.BarData.length - 1 &&
                                    nextSum > 0
                                      ? 0
                                      : 3.0
                                  }
                                  height={
                                    height -
                                    (stackIndex == 0
                                      ? scaleY(value)
                                      : scaleY(
                                          value - localValues[stackIndex - 1]
                                        ))
                                  }
                                  color={barvalue.colors[stackIndex]}
                                  onMouseEnter={(event) => {
                                    setTooltip({
                                      x: event.clientX,
                                      y: event.clientY,
                                      index: groupIndex,
                                      stackIndex: stackIndex,
                                      barIndex: OuterbarIndex,
                                    });
                                  }}
                                  onMouseLeave={() => setTooltip(null)}
                                />
                              </g>
                            </>
                          ) : (
                            <></>
                          )
                        )
                      )}
                    </>
                  )
                )
              )}
              {lineData.length > 0 && (
                <circle
                  key={"cor" + groupIndex}
                  fill={colorsForBars[0]}
                  stroke={"1"}
                  cx={scaleX.bandwidth() / 2}
                  //                cx={ ((getX(labels[(lineData[groupIndex][0]-1)])|| 0) ||0 - ( groupIndex+1 * subscaleX.bandwidth() * scaleX.bandwidth()))}
                  cy={scaleY(lineData[groupIndex][1])}
                  r={3}
                  onMouseEnter={(event) => {
                    setTooltip({
                      x: event.clientX,
                      y: event.clientY,
                      index: groupIndex,
                      stackIndex: -1,
                      barIndex: 0,
                    });
                  }}
                  onMouseLeave={() => setTooltip(null)}
                />
              )}
            </g>
          ))}
        </g>
        {lineData.length > 0 && (
          <path
            key={`path-rect-`}
            className="c-linechart-line__path"
            d={linePath}
            strokeLinecap="round"
            strokeWidth="3"
            stroke={colorsForBars[0]}
            fill="none"
          />
        )}
      </svg>
      {showLegends && (
        <div className="Legend-main3">
          {data[0].values[0].legendsHOB &&
            data[0].values[0].legendsHOB.length > 0 &&
            data[0].values[0].legendsHOB.map((Item: any, index: any) => (
              <div className="leg-item">
                <span className={"clegend-" + index}></span>
                <p>{Item}</p>
              </div>
            ))}
        </div>
      )}

      {tooltip !== null ? (
        <div
          className="tooltip"
          style={{
            top: calculateTooltipTop(tooltip.y),
            left: tooltip.x,
            // Add any additional styling as needed
          }}
        >
          <span className="tooltip__title">{labels[tooltip.index]}</span>
          <table className="tooltip__table">
            <tbody>
              {" "}
              {data[tooltip.index].values[tooltip.barIndex].legendsHOB &&
                data[tooltip.index].values[tooltip.barIndex].legendsHOB.length >
                  0 &&
                data[tooltip.index].values[tooltip.barIndex].legendsHOB.map(
                  (Item: any, index: any) => (
                    <>
                      <tr key={"rowModel444" + index}>
                        <td
                          className={
                            index == tooltip.stackIndex
                              ? "tooltip-Highlight"
                              : ""
                          }
                        >
                          {Item}
                        </td>
                        <td
                          className={
                            index == tooltip.stackIndex
                              ? "tooltip-Highlight"
                              : ""
                          }
                        >
                          {PercentageSign}
                          {data[tooltip.index].values[tooltip.barIndex].BarData[
                            index
                          ]?.toLocaleString()}
                        </td>
                      </tr>
                    </>
                  )
                )}
              {lineData.length > 0 && (
                <tr key={`div-rectrrrr` + tooltip.stackIndex}>
                  <td
                    className={
                      -1 == tooltip.stackIndex ? "tooltip-Highlight" : ""
                    }
                  >
                    Ratio
                  </td>
                  <td
                    className={
                      -1 == tooltip.stackIndex ? "tooltip-Highlight" : ""
                    }
                  >
                    {lineData[tooltip.index][1].toLocaleString() + " %"}
                  </td>
                </tr>
              )}
              {YoYGrowth.length > 0 && YoYGrowth[tooltip.index] != null && (
                <tr>
                  <td>YoY Growth</td>
                  <td>{YoYGrowth[tooltip.index].toLocaleString() + "%"}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
